// we put the z-index in a separate file, because they influence the stacking order of elements on a page
export const zIndex = {
  /** @deprecated use levels from `zIndex` instead */
  modalOrMobilePopover: 1500,
  /** @deprecated use levels from `zIndex` instead */
  sheet: 1500,
  /** @deprecated use levels from `zIndex` instead */
  backdrop: 1499,
  /** @deprecated use levels from `zIndex` instead */
  header: 99,
  /** @deprecated use levels from `zIndex` instead */
  heroContent: 98,
  /** @deprecated use levels from `zIndex` instead */
  popover: 97,
  /** @deprecated use levels from `zIndex` instead */
  menuOrDrawer: 96,
  /** @deprecated use levels from `zIndex` instead */
  anchorMenu: 50,
  // levels for z-index
  sub: -1,
  min: 0,
  level1: 1,
  level2: 10,
  level3: 50,
  level4: 100,
  level5: 1000,
  level6: 1500,
  level7: 2000,
  max: 99999,
}
